export enum BookingStorageEnum {
  rehabilitation = 'rehabilitation',
  education = 'education',
  service = 'service',
}
